import { schemaTranslations } from '@scalar/blocks/schema'
import type { ApiReferenceTranslations } from '@scalar/types/api-reference'

/** Built-in API Reference translations for zh-TW. */
export const zhTw = {
  common: {
    streamItem: '串流項目',
    description: '描述',
    httpMethod: 'HTTP 方法',
    path: '路徑',
    copyDefault: '複製預設值',
    copyExample: '複製範例值',
  },
  search: {
    label: '搜尋',
    inputLabel: '輸入搜尋查詢',
    open: '開啟搜尋',
    placeholder: '搜尋...',
    clear: '清除搜尋',
    noResults: '找不到結果',
    keyboardShortcut: '鍵盤快速鍵：',
    command: 'Command 鍵',
    control: 'Control 鍵',
    results: 'API 參考文件搜尋結果',
    navigate: '導覽',
    select: '選擇',
    instructions: '按上/下箭頭導覽，按 Enter 選擇，輸入內容篩選結果',
    entryHeading: '標題',
    entryOperation: '操作',
    entryTag: '標籤',
    entryTagGroup: '標籤群組',
    entryChannel: '通道',
    entryMessage: '訊息',
    entryWebhook: 'Webhook',
  },
  navigation: {
    introduction: '簡介',
    closeGroup: '關閉群組',
    closeMenu: '關閉選單',
    openGroup: '開啟群組',
    openMenu: '開啟選單',
    operations: '操作',
    endpoints: '{name} 端點',
    showAllEndpoints: '顯示 {name} 的所有端點',
    sidebarFor: '{name} 的側邊欄',
    mainContent: '{name} 的 API 文件',
    collapsed: '已摺疊',
    webhooks: 'Webhooks',
    channels: '通道',
  },
  server: {
    label: '伺服器',
    select: '選擇伺服器',
  },
  info: {
    termsOfService: '服務條款',
  },
  asyncapi: {
    address: '位址',
    unknownAddress: '未知',
    applicationIdentifier: '應用程式識別碼',
    servers: '伺服器',
    protocols: '通訊協定',
  },
  clientLibraries: {
    heading: '用戶端函式庫',
    more: '更多',
    selectAll: '從所有用戶端中選擇',
    searchLabel: '搜尋用戶端',
    changeClient: '更改程式碼範例語言',
  },
  operation: {
    codeSampleUnavailable: '此範例沒有可用的程式碼範例。',
    codeSample: '程式碼範例',
    body: '請求主體',
    cookies: 'Cookie',
    headers: '請求標頭',
    pathParameters: '路徑參數',
    queryParameters: '查詢參數',
    requestBody: '請求主體',
    responses: '回應',
    testRequest: '測試請求',
    webhook: 'Webhook',
    audience: '適用對象',
    selectedContentType: '已選內容類型',
    callbacks: '回呼',
  },
  response: {
    xmlGenerationLimit: 'XML 範例超出產生限制。請提供序列化的 XML 範例以顯示完整內容。',
    xmlGenerationFailed: '無法產生 XML 範例：{message}',
    exampleResponses: '回應範例',
    noBody: '無內容',
    showSchema: '顯示結構描述',
    status: '狀態',
  },
  schema: schemaTranslations['zh-TW'].schema,
  download: {
    openapi: '下載 OpenAPI 文件',
    asyncapi: '下載 AsyncAPI 文件',
    asFormat: '{label}（{format}）',
  },
  models: {
    label: '模型',
  },
  actions: {
    copyAsMarkdown: '複製為 Markdown',
    copied: '已複製',
    copyMarkdownFailed: '無法複製 Markdown',

    copyLink: '複製連結',
    copyLinkTo: '複製指向 {name} 的連結',
    copyToClipboard: '複製連結到剪貼簿',
    copyEndpointUrl: '複製端點 URL',
    showMore: '顯示更多',
  },
  agent: {
    askAi: '詢問 AI',
    askAiAgent: '詢問 AI 助手',
    close: '關閉用戶端',
  },
  mcp: {
    generate: '產生 MCP',
    connect: '連線 MCP',
  },
  sdk: {
    generate: '產生 SDK',
  },
  developerTools: {
    title: '開發者工具',
    configure: '設定',
    share: '分享',
    deploy: '部署',
    scalarConfiguration: 'Scalar 設定',
    theme: '主題',
    layout: '版面配置',
    layoutOptions: '版面配置選項',
    intro: '開發者工具可用於自訂文件的外觀和行為。你也可以透過 Scalar Registry 分享文件。',
    disableToolbarBefore: '要停用工具列，請在設定中指定',
    disableToolbarAfter: '。',
    localhostOnly: '開發者工具只會在 localhost 上執行時顯示。',
    layoutModern: '現代',
    layoutClassic: '經典',
    showSidebar: '顯示側邊欄',
    defaultOpenFirstTag: '預設開啟第一個標籤',
    defaultOpenAllTags: '預設開啟所有標籤',
    expandAll: '展開所有 {label}',
    expandAllParameters: '展開所有參數',
    expandAllSchemaProperties: '展開所有結構描述屬性',
    hideModelNames: '隱藏模型名稱',
    orderRequiredPropertiesFirst: '必填屬性優先',
    orderSchemaPropertiesBy: '結構描述屬性排序',
    alphabeticalOrder: '依字母順序',
    documentOrder: '文件順序',
    expandAllResponses: '展開所有回應',
    hideClientButton: '隱藏用戶端按鈕',
    hideDarkModeToggle: '隱藏深色模式開關',
    hideModels: '隱藏 {label}',
    hideSearch: '隱藏搜尋',
    showOperationId: '顯示操作 ID',
    hideTestRequestButton: '隱藏測試請求按鈕',
    scalarDocs: 'Scalar Docs',
    deployDescription: '將你的文件部署到 Scalar，這是適用於 API 等內容的現代文件平台。',
    shareTitle: '分享你的 API Reference',
    shareDescription: '上傳 OpenAPI 文件，與其他人分享你的 API Reference。只需點擊按鈕即可。',
    uploadDocument: '上傳文件',
    temporaryLinkExpiration: '你的文件將在 7 天後自動刪除。',
    deployOnScalar: '部署到 Scalar',
    deployFree: '免費部署你的文件。',
    additionalFeaturesMightRequire: '其他功能可能需要',
    generate: '產生',
    passwordProtection: '密碼保護',
    customDomains: '自訂網域',
    freeFormContent: '自由內容',
    cdnInfrastructure: 'CDN 基礎設施',
    pullFromGitHub: '從 GitHub 拉取',
    markdownMdx: 'Markdown/MDX',
    spectralLinting: 'Spectral Linting',
    jsonSchemaHosting: 'JSON Schema 代管',
    askAi: '詢問 AI',
    mcpServers: 'MCP 伺服器',
    unableToExportDocument: '無法匯出目前文件',
    unknownError: '發生未知錯誤',
  },
  exploreScalar: {
    cta: '產生 SDK 與 MCP',
    headline: '為你的 API 即時產生 SDK、MCP 與文件',
    title: '一份 OpenAPI 文件，滿足你的 API 所需的一切',
    generateTitle: 'SDK 與 MCP 伺服器',
    generateDescription: '根據此文件產生具型別的用戶端函式庫與 MCP 伺服器，並保持同步。',
    platformTitle: '文件、開發者入口網站與註冊中心',
    platformDescription: '發布含指南的 API 參考文件，將你的 API 託管在註冊中心，並在 API 用戶端中測試。',
    signUp: '免費試用',
    bookDemo: '預約與我們的 CEO Marc 進行產品展示',
    getDemo: '或預約與 Marc 進行產品展示',
    messageMarc: '在 X 上私訊 Marc',
    dmMarc: '或直接在 X 上私訊我！',
    close: '關閉',
    opensInNewTab: '在新分頁中開啟',
    popupBlocked: '瀏覽器封鎖了新分頁。請再按一次該按鈕以開啟。',
    back: '返回',
    openBookingPage: '開啟預約頁面',
  },
  gettingStarted: {
    swaggerEditor: 'Swagger Editor',
    description:
      '歡迎使用 Scalar API References + Swagger Editor，這是一款免費的開源工具，可將你的 Swagger/OAS 檔案產生精美的 API References。',
    showExample: '顯示範例',
    uploadFile: '上傳檔案',
    integrations: '整合',
    theming: '主題',
    features: '功能',
    customize: '自訂',
    customizeDescription: '使用你的排版和調色盤，或使用我們的主題！',
    testing: '測試',
    testingDescription: '深度整合的 REST API Client（同樣免費且開源）',
    search: '搜尋',
    searchDescription: '完整整合的搜尋（使用 fuse.js）',
    hosting: '代管',
    hostingDescription: '在 https://apidocumentation.com 上免費代管子網域',
    openApiSwagger: 'OpenAPI 和 Swagger',
    openApiSwaggerDescription: '支援 OpenAPI 3.1、OpenAPI 3.0 和 Swagger 2.0',
    codeSamples: '程式碼範例',
    codeSamplesDescription: '使用最常見的語言展示你的 API 的程式碼範例',
  },
  footer: {
    poweredByScalar: '由 Scalar 提供支援',
  },
  authentication: {
    detailsRequired: '需要身分驗證',
    detailsOptional: '身分驗證為選用',
    apiKey: 'API 金鑰',
    mutualTLS: '雙向 TLS',
    apiKeyCookie: '在 Cookie 「{name}」 中傳送 API 金鑰。',
    apiKeyHeader: '在請求標頭 「{name}」 中傳送 API 金鑰。',
    apiKeyQuery: '在查詢參數 「{name}」 中傳送 API 金鑰。',
    title: '身分驗證',
    accepts: '接受',
    allOf: '全部：',
    authentication: '身分驗證',
    optional: '身分驗證為選用',
    oneOf: '其中之一：',
    required: '需要身分驗證',
    requires: '需要',
    scopes: 'OAuth 權限範圍',
  },
} satisfies ApiReferenceTranslations
